/**
 * Created by vaibhav on 31/3/18
 */
module.exports = {
  siteTitle: 'Razy Technologies', // Site title.
  siteTitleAlt: 'razy tech', // Alternative site title for SEO.
  siteLogo: '/img/razy-logo.png', // Logo used for SEO and manifest.
  siteUrl: 'http://razytech.com', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'Razy Technologies, we position ourselves, as a group of companies, a super achiever due to our projects’ extraordinary ROI and clients’ satisfaction. We provide a seamless optimized wide range of offerings being the tech backbone to all of our success partners.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: '', // GTM tracking ID.
  disqusShortname: 'razy-tech', // Disqus shortname.
  userName: '',
  userTwitter: '',
  userLocation: '',
  userDescription: '',
  copyright: 'All rights reserved to RZAY TECHNOLOGIES, created with <3 at TALK, LLC', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
}



// WEBPACK FOOTER //
// ./meta/config.js